import { render, staticRenderFns } from "./BoxPixKeyRegistered.vue?vue&type=template&id=39fc0408&scoped=true&"
import script from "./BoxPixKeyRegistered.vue?vue&type=script&lang=js&"
export * from "./BoxPixKeyRegistered.vue?vue&type=script&lang=js&"
import style0 from "./BoxPixKeyRegistered.vue?vue&type=style&index=0&id=39fc0408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc0408",
  null
  
)

export default component.exports